import script from "./WorkDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkDetails.vue?vue&type=script&setup=true&lang=ts"

import "./WorkDetails.vue?vue&type=style&index=0&id=07671827&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07671827"]])

export default __exports__